/* eslint-disable */
import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { setLoading } from './loading'
import { API } from 'src/services/config'
import { AnimalProps } from 'src/@types/Animal'

export interface AnimalState {
  loading: boolean
  list: Array<AnimalProps>
  animalListByLot: {
    list: Array<AnimalProps>
    loading: boolean
  }
}

const customModule = '@ANIMAL'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`
}
const GET_BY_LOTE = {
  REQUEST: `${customModule}/GET_BY_LOTE_REQUEST`,
  SUCCESS: `${customModule}/GET_BY_LOTE_SUCCESS`
}

const SET_FETCHING = `${customModule}/SET_FETCHING`

const initialState: AnimalState = {
  list: [],
  loading: false,
  animalListByLot: {
    list: [],
    loading: false
  }
}

export const animalReducer: Reducer<AnimalState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.REQUEST:
      return { ...state, loading: true }
    case GET.SUCCESS:
      return { ...state, list: payload, loading: false }
    case GET_BY_LOTE.REQUEST:
      return {
        ...state,
        animalListByLot: {
          ...state.animalListByLot,
          loading: true
        }
      }
    case GET_BY_LOTE.SUCCESS:
      return {
        ...state,
        animalListByLot: {
          list: payload,
          loading: false
        }
      }
    default:
      return state
  }
}

export const setFetching = (data: boolean) => ({ type: SET_FETCHING, payload: data })
export const getAnimalListByFarmId = (farmId: string, onSuccess?: (data: AnimalProps[]) => void) => ({
  type: GET.REQUEST,
  payload: { farmId, onSuccess }
})
export const getAnimalListByLoteId = (farmId: string, loteId: string) => ({
  type: GET_BY_LOTE.REQUEST,
  payload: { farmId, loteId }
})

const ROUTE = '/entity/Animal'

// eslint-disable-next-line
function* get({ payload }: SagaAction<{ farmId: string; onSuccess?: (data: AnimalProps[]) => void }>) {
  try {
    yield put(setLoading(true))
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}/${payload.farmId}`)
    yield put({ type: GET.SUCCESS, payload: data })
    yield put(setLoading(false))
    if (payload.onSuccess) {
      payload.onSuccess(data)
    }
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar propriedades. Tente novamente.'
    toast.error(message)
    yield put(setLoading(false))
  }
}

function* getAnimalListByLote({ payload }: SagaAction<{ farmId: string; loteId: string }>) {
  try {
    const { farmId, loteId } = payload
    yield put(setLoading(true))
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}/${farmId}/${loteId}/Lote`)
    yield put({ type: GET_BY_LOTE.SUCCESS, payload: data })
    yield put(setLoading(false))
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar propriedades. Tente novamente.'
    toast.error(message)
    yield put(setLoading(false))
  }
}

export const animalSaga = all([takeLatest(GET.REQUEST, get), takeLatest(GET_BY_LOTE.REQUEST, getAnimalListByLote)])
